import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import {
  clearMainAppLocalSession,
  clearMemoriesLogoutGuard,
  sanitizeLogoutReturnUrl,
} from '../utils/memoriesAuthBridge';

/**
 * Main app: clear traveler JWT on this origin, then continue.
 * Used so a Memories logout cannot be undone by the auth bridge.
 * Storage-only clear — avoid AuthContext setState mid-hop.
 */
const MemoriesAuthLogout = () => {
  const [params] = useSearchParams();
  const returnUrl = sanitizeLogoutReturnUrl(params.get('return'));

  useEffect(() => {
    clearMainAppLocalSession();
    clearMemoriesLogoutGuard();
    window.location.replace(returnUrl);
  }, [returnUrl]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="50vh"
      gap={2}
    >
      <CircularProgress size={36} />
      <Typography variant="body2" color="text.secondary">
        Signing you out…
      </Typography>
    </Box>
  );
};

export default MemoriesAuthLogout;
